/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdrawconfirmbody3Inputs */

const en_dropdrawconfirmbody3 = /** @type {(inputs: Dropdrawconfirmbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This ranks all entries in a verifiable random order, picks the winners, and notifies them. Write and send the winner message afterwards. It cannot be repeated.`)
};

const de_dropdrawconfirmbody3 = /** @type {(inputs: Dropdrawconfirmbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Teilnahmen werden nachprüfbar zufällig gereiht, die Gewinner ermittelt und per Mitteilung benachrichtigt. Schreib danach die Gewinner-Nachricht. Das kann nicht wiederholt werden.`)
};

/**
* | output |
* | --- |
* | "This ranks all entries in a verifiable random order, picks the winners, and notifies them. Write and send the winner message afterwards. It cannot be repeated." |
*
* @param {Dropdrawconfirmbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdrawconfirmbody3 = /** @type {((inputs?: Dropdrawconfirmbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdrawconfirmbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdrawconfirmbody3(inputs)
	return de_dropdrawconfirmbody3(inputs)
});
export { dropdrawconfirmbody3 as "dropDrawConfirmBody" }